/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceActionsCatalogEntry {
    getFixupPrototypeFunction() { return ResourceActionsCatalogEntry.fixupPrototype; }

    static newInstance(model: Partial<ResourceActionsCatalogEntry>): ResourceActionsCatalogEntry {
        let obj = Object.assign(new ResourceActionsCatalogEntry(), model);
        ResourceActionsCatalogEntry.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceActionsCatalogEntry>): ResourceActionsCatalogEntry {
        if (!model) return null;
        return ResourceActionsCatalogEntry.newInstance(<ResourceActionsCatalogEntry> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceActionsCatalogEntry) {
        if (!obj) return;

        models.ResourceActionsCatalogEntry.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceActionsCatalogEntry): boolean {
        Object.setPrototypeOf(obj, ResourceActionsCatalogEntry.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.management_actions) {
            for (let val of this.management_actions) {
                models.ResourceManagementAction.fixupPrototype(val);
            }
        }
        if (this.management_action_constraint) {
            for (let val of this.management_action_constraint) {
                models.ResourceActionConstraint.fixupPrototype(val);
            }
        }
        if (this.templates) {
            for (let val of this.templates) {
                models.ResourceCreateTemplate.fixupPrototype(val);
            }
        }
        if (this.positions) {
            for (let val of this.positions) {
                models.ResourceColumnPosition.fixupPrototype(val);
            }
        }
    }

    /**
     * Management actions supported for this resource type
     */
    management_actions: Array<models.ResourceManagementAction>;

    /**
     * Rules gating an action on the resource's current state
     */
    management_action_constraint: Array<models.ResourceActionConstraint>;

    /**
     * Whether relationships are available for this resource type
     */
    enable_relationship: boolean;

    /**
     * Whether utilization metrics are available for this resource type
     */
    enable_utilization: boolean;

    /**
     * Automation templates in the caller's tenant that create this resource type
     */
    templates: Array<models.ResourceCreateTemplate>;

    /**
     * Grid columns declared for this resource type, in position order - the same columns the list endpoint's rows are rendered with
     */
    positions: Array<models.ResourceColumnPosition>;

}
